/*
  ZUCK 2026-10-14 — PDP buy box, items 15 + 16 (Versiani).

  15. A bare product URL opens with NO size chosen (colour stays selected). The size radios of the
      main picker are unchecked; the shopper's picks are remembered and re-applied after every Dawn
      re-render (colour switch). Until every size is picked the main button reads "Selecione um
      tamanho" / "Selecione os tamanhos" and a click shows "Por favor, selecione um tamanho" under it,
      scrolls to the sizes and highlights them. The submit is blocked in the CAPTURE phase, so Dawn's
      product-form never sees it. If this file fails, the page behaves as before (server keeps the
      default variant checked). "Monte seu kit" follows the same rule per item, but its radios stay
      checked (its own JS needs them to price the kit) — the chips just look unchosen until tapped.
      An explicit ?variant= (ads, cart links) is honoured fully: nothing changes. Single-size options
      (one value, or U / Único) count as chosen. Quick-add is untouched.
  16. Centred pill sticky ATC (snippets/zuck-sticky-atc.liquid): shows only after the active buy
      button has scrolled out of view above (IntersectionObserver), same label as that button + price.
      Tapping it clicks the real button, so the size rule above applies.
*/
(function () {
  if (window.__zuckPdpBuy) return;
  window.__zuckPdpBuy = true;

  // A ?variant= keeps the full variant (size included) ONLY on an ad/catalogue landing: tracking params,
  // or a referrer that is not this site (empty = external). Internal links (cards, recs, Compre junto
  // all carry ?variant=) keep the colour and open with no size.
  function fullVariantVisit() {
    var qs = new URLSearchParams(window.location.search);
    if (!qs.has('variant')) return false;
    var AD = ['gclid', 'fbclid', 'gbraid', 'wbraid', 'srsltid', '_pos', '_sid', '_ss', '_psq', 'dclid', 'msclkid', 'ttclid'];
    var ad = false;
    qs.forEach(function (_, k) { if (/^utm_/i.test(k) || AD.indexOf(k) !== -1) ad = true; });
    if (ad) return true;
    var ref = document.referrer, same = false;
    try { same = !!ref && new URL(ref).origin === window.location.origin; } catch (_) {}
    return !same;
  }
  var EXPLICIT = fullVariantVisit();
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ADD = (window.variantStrings && window.variantStrings.addToCart) || 'Adicionar ao carrinho';
  var chosen = {}; // sectionKey -> { optionName: true }
  var kitChosen = new WeakMap(); // kit card -> { groupLabel: true }
  var LBL_ONE = 'Selecione um tamanho';
  var LBL_MANY = 'Selecione os tamanhos';

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function isColorName(n) {
    n = (n || '').toLowerCase();
    return (n.indexOf('cor') !== -1 || n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) &&
      n.indexOf('tamanho') === -1 && n.indexOf('size') === -1;
  }
  function isSingleSize(inputs) {
    if (inputs.length <= 1) return true;
    return inputs.length === 1 || inputs.every(function (i) { return /^(u|único|unico|tamanho único|tamanho unico)$/i.test(norm(i.value)); });
  }
  function piece(name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('top') !== -1) return 'do top';
    if (n.indexOf('calcinha') !== -1) return 'da calcinha';
    if (n.indexOf('short') !== -1) return 'do short';
    return '';
  }
  function scrollOpts() { return { block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' }; }
  /* Highlight ring: an overlay sized to EXACTLY the group's label + tiles (+6px), because a <fieldset>
     paints its box through the middle of its legend. It stays until a size in that group is picked. */
  var rings = {};
  function ring(id, els, pulse) {
    var rects = els.filter(Boolean).map(function (e) { return e.getBoundingClientRect(); }).filter(function (r) { return r.width && r.height; });
    if (!rects.length) { dropRing(id); return; }
    var l = Math.min.apply(null, rects.map(function (r) { return r.left; })), t = Math.min.apply(null, rects.map(function (r) { return r.top; }));
    var rr = Math.max.apply(null, rects.map(function (r) { return r.right; })), b = Math.max.apply(null, rects.map(function (r) { return r.bottom; }));
    var d = rings[id];
    if (!d) { d = rings[id] = document.createElement('span'); /* not a div: Dawn hides div:empty */ d.className = 'zuck-size-ring'; d.setAttribute('aria-hidden', 'true'); document.body.appendChild(d); }
    d.style.left = (l + window.scrollX - 6) + 'px';
    d.style.top = (t + window.scrollY - 6) + 'px';
    d.style.width = (rr - l + 12) + 'px';
    d.style.height = (b - t + 12) + 'px';
    if (pulse) { d.classList.remove('is-pulse'); void d.offsetWidth; d.classList.add('is-pulse'); }
  }
  function dropRing(id) { if (rings[id]) { rings[id].remove(); delete rings[id]; } }
  var flagged = {}; // ring id -> true (main: rootKey|option)
  function groupEls(f) {
    var lg = f.querySelector('legend, .main-product-kits__option-label');
    var tiles = Array.prototype.slice.call(f.querySelectorAll('label, .main-product-kits__chip'));
    return [lg].concat(tiles);
  }

  /* ---------------- main picker ---------------- */
  function roots() {
    return Array.prototype.filter.call(document.querySelectorAll('product-info'), function (r) {
      return !r.closest('quick-add-modal') && r.querySelector('variant-selects');
    });
  }
  function keyOf(root) { return root.id || root.dataset.section || 'main'; }
  function sizeFieldsets(root) {
    var vs = root.querySelector('variant-selects');
    if (!vs) return [];
    return Array.prototype.filter.call(vs.querySelectorAll('fieldset'), function (f) {
      var lg = f.querySelector('legend');
      var name = norm(lg ? lg.textContent.replace(/:.*$/, '') : '');
      var inputs = Array.prototype.slice.call(f.querySelectorAll('input[type="radio"]'));
      f.dataset.zuckOption = name;
      return inputs.length && !isColorName(name) && !isSingleSize(inputs);
    });
  }
  function pending(root) {
    if (EXPLICIT) return [];
    var c = chosen[keyOf(root)] || {};
    return sizeFieldsets(root).filter(function (f) { return !c[f.dataset.zuckOption]; });
  }
  function mainButton(root) { return root.querySelector('.product-form__submit[name="add"]'); }
  function msgNode(root) { return root.querySelector('[data-zuck-size-msg]'); }
  function missingText(root, list) {
    var total = sizeFieldsets(root).length;
    if (total <= 1) return 'Por favor, selecione um tamanho';
    if (list.length >= total) return 'Selecione os tamanhos';
    var p = piece(list[0].dataset.zuckOption);
    return p ? 'Selecione o tamanho ' + p : 'Selecione o tamanho';
  }
  function apply(root) {
    var list = pending(root);
    list.forEach(function (f) {
      f.querySelectorAll('input[type="radio"]:checked').forEach(function (i) { i.checked = false; });
    });
    root.classList.toggle('zuck-size-pending', list.length > 0);
    var k = keyOf(root);
    sizeFieldsets(root).forEach(function (f) {
      var id = k + '|' + f.dataset.zuckOption;
      var miss = flagged[id] && list.indexOf(f) !== -1;
      f.classList.toggle('zuck-size-missing', !!miss);
      if (miss) ring(id, groupEls(f), false); else { dropRing(id); delete flagged[id]; }
    });
    var btn = mainButton(root);
    var span = btn && btn.querySelector('span');
    if (span && !btn.disabled) {
      var want = list.length ? (sizeFieldsets(root).length > 1 ? LBL_MANY : LBL_ONE) : null;
      if (want && norm(span.textContent) !== want) span.textContent = want;
      if (!want && (norm(span.textContent) === LBL_ONE || norm(span.textContent) === LBL_MANY)) span.textContent = ADD;
    }
    if (!list.length) { var m = msgNode(root); if (m && m.textContent) m.textContent = ''; }
  }

  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('variant-selects fieldset');
    if (!f) return;
    var root = f.closest('product-info');
    if (!root || root.closest('quick-add-modal')) return;
    var name = f.dataset.zuckOption || norm((f.querySelector('legend') || {}).textContent || '').replace(/:.*$/, '');
    if (!isColorName(name)) {
      var k = keyOf(root);
      (chosen[k] = chosen[k] || {})[name] = true;
      var m = msgNode(root);
      var left = pending(root);
      if (m && m.textContent) m.textContent = left.length ? missingText(root, left) : '';
      schedule();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    // main product form
    var root = form.closest('product-info') || (form.id && document.querySelector('product-info [form="' + form.id + '"]') && document.querySelector('product-info [form="' + form.id + '"]').closest('product-info'));
    if (root && !root.closest('quick-add-modal') && form.matches('form[id^="product-form-"]')) {
      var list = pending(root);
      if (list.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var m = msgNode(root);
        if (m) m.textContent = missingText(root, list);
        list[0].scrollIntoView(scrollOpts());
        var rk = keyOf(root);
        list.forEach(function (f) { var id = rk + '|' + f.dataset.zuckOption; flagged[id] = true; f.classList.add('zuck-size-missing'); ring(id, groupEls(f), true); });
        setTimeout(schedule, reduceMotion.matches ? 0 : 450);
        var first = list[0].querySelector('input[type="radio"]:not([disabled])');
        if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (_) {} }, reduceMotion.matches ? 0 : 350);
        return;
      }
    }
    // "Monte seu kit"
    if (form.matches('[data-kit-form]')) {
      var miss = kitPending(form);
      if (miss.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var km = kitMsg(form);
        km.textContent = kitMissingText(form, miss);
        miss[0].group.scrollIntoView(scrollOpts());
        miss.forEach(function (x) { x.group.__zuckFlag = true; ring(kitRingId(x.group), groupEls(x.group), true); });
        setTimeout(schedule, reduceMotion.matches ? 0 : 450);
      }
    }
  }, true);

  /* ---------------- "Monte seu kit" ---------------- */
  function kitGroups(card) {
    return Array.prototype.filter.call(card.querySelectorAll('[data-kit-dynamic-options] [data-option-index]'), function (g) {
      var label = norm((g.querySelector('.main-product-kits__option-label') || {}).textContent || '').replace(/:.*$/, '');
      g.dataset.zuckOption = label;
      var inputs = Array.prototype.slice.call(g.querySelectorAll('input[type="radio"]'));
      return inputs.length && !isColorName(label) && !isSingleSize(inputs);
    });
  }
  function cardEnabled(card) {
    var t = card.querySelector('[data-kit-enabled]');
    return !t || t.checked;
  }
  function kitPending(form) {
    if (EXPLICIT) return [];
    var out = [];
    form.querySelectorAll('[data-kit-card]').forEach(function (card, idx) {
      if (!cardEnabled(card)) return;
      var c = kitChosen.get(card) || {};
      kitGroups(card).forEach(function (g) { if (!c[g.dataset.zuckOption]) out.push({ card: card, idx: idx, group: g }); });
    });
    return out;
  }
  function kitMsg(form) {
    var n = form.querySelector('[data-zuck-kit-size-msg]');
    if (!n) {
      n = document.createElement('p');
      n.className = 'zuck-size-msg';
      n.setAttribute('data-zuck-kit-size-msg', '');
      n.setAttribute('aria-live', 'polite');
      n.setAttribute('role', 'status');
      var btn = form.querySelector('[data-kit-submit]');
      (btn ? btn.parentNode : form).insertBefore(n, btn ? btn.nextSibling : null);
    }
    return n;
  }
  function kitMissingText(form, miss) {
    var cards = {};
    miss.forEach(function (x) { cards[x.idx] = (cards[x.idx] || []).concat(x.group.dataset.zuckOption); });
    var keys = Object.keys(cards);
    if (keys.length > 1) return 'Selecione os tamanhos de todas as peças do kit';
    var names = cards[keys[0]];
    var all = kitGroups(miss[0].card).length;
    if (names.length >= all && all > 1) return 'Selecione os tamanhos';
    var p = piece(names[0]);
    return p ? 'Selecione o tamanho ' + p : (all > 1 ? 'Selecione os tamanhos' : 'Por favor, selecione um tamanho');
  }
  var kitIds = 0;
  function kitRingId(g) { if (!g.__zuckRing) g.__zuckRing = 'kit' + (++kitIds); return g.__zuckRing; }
  function applyKit(form) {
    var miss = kitPending(form);
    form.querySelectorAll('[data-kit-card]').forEach(function (card) {
      var c = kitChosen.get(card) || {};
      kitGroups(card).forEach(function (g) {
        var open = !EXPLICIT && !c[g.dataset.zuckOption];
        g.classList.toggle('zuck-kit-unchosen', open);
        var show = open && g.__zuckFlag && cardEnabled(card) && !!g.offsetParent;
        g.classList.toggle('zuck-size-missing', !!show);
        if (show) ring(kitRingId(g), groupEls(g), false); else if (g.__zuckRing) { dropRing(g.__zuckRing); if (!open) g.__zuckFlag = false; }
      });
    });
    var btn = form.querySelector('[data-kit-submit]');
    if (btn) {
      if (!btn.dataset.zuckLabel) btn.dataset.zuckLabel = norm(btn.textContent);
      var want = miss.length ? LBL_MANY : btn.dataset.zuckLabel;
      if (norm(btn.textContent) !== want && !btn.classList.contains('loading')) btn.textContent = want;
    }
    var n = form.querySelector('[data-zuck-kit-size-msg]');
    if (n && n.textContent) n.textContent = miss.length ? kitMissingText(form, miss) : '';
  }
  // a click on an ALREADY checked chip fires no change event, so listen to clicks
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-kit-form] [data-kit-dynamic-options] [data-option-index] label, [data-kit-form] [data-kit-dynamic-options] [data-option-index] input');
    if (!chip) return;
    var g = chip.closest('[data-option-index]');
    var card = chip.closest('[data-kit-card]');
    if (!g || !card || !g.dataset.zuckOption || isColorName(g.dataset.zuckOption)) return;
    var c = kitChosen.get(card) || {};
    c[g.dataset.zuckOption] = true;
    kitChosen.set(card, c);
    schedule();
  }, true);

  /* ---------------- sticky pill ---------------- */
  var pills = [];
  function setupPill(pill) {
    if (pill.__zuckReady) return;
    pill.__zuckReady = true;
    var section = pill.closest('.shopify-section') || document;
    var root = section.querySelector('product-info');
    var state = { pill: pill, root: root, section: section, seen: {} };
    pills.push(state);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { state.seen[en.target.__zuckKey] = en; });
      updatePill(state);
    });
    state.io = io;
    function watch() {
      var m = mainButton(root || section), k = section.querySelector('[data-kit-submit]');
      [m, k].forEach(function (b, i) { if (b && !b.__zuckKey) { b.__zuckKey = i ? 'kit' : 'main'; io.observe(b); } });
    }
    state.watch = watch;
    watch();
    pill.querySelector('[data-zuck-sticky-btn]').addEventListener('click', function () {
      var t = target(state);
      if (!t) return;
      t.scrollIntoView(scrollOpts());
      t.click();
    });
    section.addEventListener('click', function (e) {
      if (e.target.closest('[data-tab-target]')) setTimeout(function () { updatePill(state); }, 50);
    });
  }
  function target(state) {
    // follow the ACTIVE tab: the kit panel can be rendered (offsetParent set) while "Conjunto" is the tab in use
    var k = state.section.querySelector('[data-kit-submit]');
    var m = mainButton(state.root || state.section);
    var tab = state.section.querySelector('[data-tab-target].is-active');
    if (tab && tab.getAttribute('data-tab-target') === 'kit' && k) return k;
    if (m && m.offsetParent && !m.closest('[hidden]')) return m;
    if (k && k.offsetParent && !k.closest('[hidden]')) return k;
    return null;
  }
  function priceText(state, t) {
    if (t && t.matches('[data-kit-submit]')) {
      var kt = state.section.querySelector('[data-kit-total]');
      return kt ? norm(kt.textContent) : '';
    }
    var box = state.section.querySelector('[id^="price-"] .price');
    if (!box) return '';
    var sale = box.classList.contains('price--on-sale') ? box.querySelector('.price-item--sale') : box.querySelector('.price-item--regular');
    return sale ? norm(sale.textContent) : '';
  }
  function updatePill(state) {
    var t = target(state);
    var show = false;
    if (t) {
      var r = t.getBoundingClientRect();
      show = r.bottom < 0;
    }
    var pill = state.pill;
    if (t) {
      var label = t.matches('[data-kit-submit]') ? norm(t.textContent) : norm((t.querySelector('span') || t).textContent);
      var l = pill.querySelector('[data-zuck-sticky-label]');
      var p = pill.querySelector('[data-zuck-sticky-price]');
      if (l && norm(l.textContent) !== label) l.textContent = label;
      var pt = priceText(state, t);
      if (p && norm(p.textContent) !== pt) p.textContent = pt;
      pill.classList.toggle('is-disabled', !!t.disabled);
    }
    if (pill.classList.contains('is-visible') !== show) {
      pill.classList.toggle('is-visible', show);
      pill.setAttribute('aria-hidden', show ? 'false' : 'true');
      var b = pill.querySelector('[data-zuck-sticky-btn]');
      if (b) b.tabIndex = show ? 0 : -1;
    }
  }

  /* ---------------- driver ---------------- */
  var queued = false;
  function run() {
    queued = false;
    roots().forEach(apply);
    document.querySelectorAll('[data-kit-form]').forEach(applyKit);
    document.querySelectorAll('[data-zuck-sticky-atc]').forEach(setupPill);
    pills.forEach(function (s) { s.watch(); updatePill(s); });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(run); } }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // back/forward cache: the page comes back with the old picks — apply the rule again from scratch
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    EXPLICIT = fullVariantVisit();
    chosen = {};
    kitChosen = new WeakMap();
    schedule();
  });
})();
